import React from 'react';
import clsx from 'clsx';
import { useImagePreload } from '../../hooks/useImagePreload';
import OrderButton from '../ui/OrderButton';

const BackgroundImage = ({ url, children }) => {
  const [isImageLoaded, setIsImageLoaded] = React.useState(false);

  // Restaurant theme color - warm amber/brown
  const dominantColor = "bg-amber-800"; 

  React.useEffect(() => {
    const img = new Image();
    img.src = url;
    img.onload = () => setIsImageLoaded(true);
  }, [url]);

  return (
    <div className="relative w-full min-h-[80vh]"> {/* Increased min-height for better hero presence */}
      {/* Solid color placeholder */}
      <div 
        className={`absolute inset-0 ${dominantColor} transition-opacity duration-700 ease-in-out ${
          isImageLoaded ? 'opacity-0' : 'opacity-100'
        }`}
      />
      

      {/* Main background image */}
      <div 
        className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
          isImageLoaded ? 'opacity-100' : 'opacity-0'
        }`}
        style={{
          backgroundImage: `url(${url})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <img src={`${url}`} hidden />
        </div>
      
      {/* Dark overlay - reduced opacity for better image visibility */}
      <div className="absolute inset-0 bg-black opacity-70" />
      
      {/* Content */}
      {children}
    </div>
  );
};

const Hero = ({heroData}) => {
  // Preload the background image
  useImagePreload([heroData.backgroundImage]);
  
  const sectionClasses = clsx(
    "relative", // Removed py-20 as we'll handle padding in content
    {
      [heroData.backgroundColor]: heroData.backgroundType === "color",
      "text-white": heroData.backgroundType === "image",
    }
  );

  return (
    <section className={sectionClasses}>
      {heroData.backgroundType === "image" ? (
        <BackgroundImage url={heroData.backgroundImage}>
          <HeroContent heroData={heroData} />
        </BackgroundImage>
      ) : (
        <div className="min-h-[80vh] relative">
          <HeroContent heroData={heroData} />
        </div>
      )}
    </section>
  );
};

const HeroContent = ({ heroData }) => {
  const handleMenuShow = () => {
    const createMenu = document.createElement('iframe');
    createMenu.id = 'gfOrderFrm';
    createMenu.allowpaymentrequest = "true";
    createMenu.src = 'https://www.foodbooking.com/ordering/?restaurant_uid=c40c7189-7fc6-41af-835d-284faab90373&amp;return_url=http%3A%2F%2Flocalhost%3A5173%2F';
    createMenu.style = "z-index: 999998 !important; border: 0 !important; position:fixed !important; top:0 !important; left:0 !important; right:0 !important; bottom:0 !important; width:100% !important; height:100% !important; visibility: visible; opacity: 1;";
    createMenu.onmousewheel = "";
    document.body.appendChild(createMenu);
  };

  return (
    <div className="relative z-10 h-full flex items-center"> {/* Added flex centering */}
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-3xl">
          <p className={`uppercase text-sm mb-2 ${
            heroData.backgroundType === "image" ? "text-gray-200" : "text-gray-600"
          }`}>
            {heroData.tagline}
          </p>
          <h1 className="font-display text-5xl md:text-6xl mb-6">
            {heroData.title}
          </h1>
          <p className={`text-xl mb-8 ${
            heroData.backgroundType === "image" ? "text-gray-200" : "text-gray-600"
          }`}>
            {heroData.description}
          </p>
          <OrderButton className="bg-primary text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-primary/90 transition-colors">
            See Menu & Order
          </OrderButton>
        </div>
      </div>
    </div>
  );
};

export default Hero;